// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"sectionHeader--203a5"};